import { useToasts } from "@certn/cascadia";
import { GridItem, useColors } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { css } from "@emotion/css";
import { useField } from "formik";
import { useEffect } from "react";

import { SelfieUpload } from "./SelfieUpload";
import { usePhotoVerificationStyles } from "./styles";

type PhotoVerificationCheckField =
  components["schemas"]["PhotoVerificationCheckField"];

export function PhotoVerificationInputField({
  field,
}: {
  field: PhotoVerificationCheckField;
}) {
  const styles = usePhotoVerificationStyles();
  const [, meta, helpers] = useField(field.name);
  const { show } = useToasts();
  const colors = useColors();

  useEffect(() => {
    if (meta.error) {
      show({
        title: meta.error,
        type: "error",
      });
      helpers.setError(undefined);
    }
  }, [meta.error]);

  return (
    <GridItem>
      <div
        className={css(styles.container, {
          backgroundColor: colors["background-accent-neutral-weak"],
        })}
      >
        {field.value ? (
          <img
            alt="selfie"
            className={styles.image}
            src={field.value.get_url}
          />
        ) : (
          <SelfieUpload
            onUpload={(documentId: string) =>
              helpers.setValue({ id: documentId })
            }
          />
        )}
      </div>
    </GridItem>
  );
}
